<input
  #input
  class="peer sr-only"
  [type]="type"
  [id]="id"
  [checked]="checked"
  [attr.name]="name"
  [attr.value]="value"
  [disabled]="disabled"
  (change)="onInputChange($event)"
  (click)="onInputClick()"
/>
<label
  [for]="id"
  class="m-0 inline-flex size-full cursor-pointer select-none flex-col gap-2 rounded-md border border-solid border-default bg-default p-4 text-base font-semibold text-default outline-none outline-offset-2 hover:border-brand peer-checked:border-brand peer-checked:bg-brand-subtle peer-focus:border-brand peer-focus:outline peer-focus:outline-2 peer-focus:outline-brand peer-disabled:pointer-events-none peer-disabled:opacity-30"
>
  <!-- Fixed height to "reserve" the space when unchecked and no badge -->
  <div class="mb-2 flex h-5 items-center justify-between">
    @if (checked) {
      <sb-icon [name]="'check-circle-solid'" [size]="'xl'" class="text-brand" />
    }
    @if (badge) {
      <sb-badge class="ml-auto" [color]="'primary'">{{ badge }}</sb-badge>
    }
  </div>
  <div>
    <ng-content></ng-content>

    <div class="font-normal text-support empty:hidden">
      <ng-content select="[description]"></ng-content>
    </div>
  </div>
</label>
